module.exports = __webpack_public_path__ + "static/media/nike-eor-winning-isnt-for-everyone-lost.c216b415.mp4";